import {
  TrustpilotRoot,
  ReviewsWrapper,
  FloatImage1,
  FloatImage2,
  TrustpilotContent,
  TrustpilotContainer,
} from './TrustpilotSection.styles'
import { Trustpilot } from 'features/components/Trustpilot'
import heart from '../../../../../public/assets/recipes/categories/wfr-heart.png'
import food from '../../../../../public/assets/reviews/food-bowl.png'
import Image from 'next/image'

export const TrustpilotSection = () => {
  return (
    <TrustpilotRoot>
      <TrustpilotContainer>
        <ReviewsWrapper>
          <TrustpilotContent>
            <Trustpilot dataTemplateId="5419b6ffb0d04a076446a9af" theme="light" />
          </TrustpilotContent>
        </ReviewsWrapper>
        <FloatImage1>
          <Image src={food} alt="" />
        </FloatImage1>
        <FloatImage2>
          <Image src={heart} alt="" />
        </FloatImage2>
      </TrustpilotContainer>
    </TrustpilotRoot>
  )
}
